// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3C7A4","signatureBlock":"Footer_signatureBlock__CdHii","signature":"Footer_signature__EOt19"};